// Remembers, per booking session, that it came from a creator-hosted link
// (website adds creator_hosted=1 to the booking URL). The URL param is
// dropped on stage navigation, so this keeps it across stages, refreshes and
// other tabs on the same device (e.g. the "Got to go?" resume link).
// localStorage can be unavailable or throw (private mode, quota, disabled
// storage); then the flag only lives in memory for this page load.
const keyFor = (sessionId: string) => `creator-hosted:${sessionId}`;
const inMemory = new Set<string>();

const creatorHostedSessionService = {
  mark(sessionId: string) {
    if (!sessionId) return;
    try {
      localStorage.setItem(keyFor(sessionId), '1');
    } catch {
      inMemory.add(sessionId);
    }
  },
  has(sessionId: string) {
    if (!sessionId) return false;
    try {
      if (localStorage.getItem(keyFor(sessionId)) === '1') return true;
    } catch {
      // fall through to the in-memory flag
    }
    return inMemory.has(sessionId);
  },
};

export { creatorHostedSessionService };
